module.exports = __webpack_public_path__ + "static/cnb-logo-3110591c545c7a4f85565e8650989519.jpg";